import { render } from "./dealsDashBoard.vue?vue&type=template&id=987240e6&scoped=true"
import script from "./dealsDashBoard.vue?vue&type=script&lang=js"
export * from "./dealsDashBoard.vue?vue&type=script&lang=js"

import "./dealsDashBoard.vue?vue&type=style&index=0&id=987240e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987240e6"]])

export default __exports__